<script setup lang="ts">
import { Web3authFooter } from "@toruslabs/vue-components";
import { Modal } from "@toruslabs/vue-components/Modal";
import { onBeforeMount, onMounted, ref } from "vue";

import { useAppStore } from "../store/appStore";
import { EMBED_MESSAGE_TYPES } from "../utils/enums";
import { EmbedMessageData, InitEmbedMessageData, ShowNFTCheckoutEmbedMessageData } from "../utils/types";

onBeforeMount(() => {
  const html = document.getElementsByTagName("html")[0];
  const body = document.getElementsByTagName("body")[0];
  html.style.background = "transparent";
  body.style.background = "transparent";
});

const isOpen = ref(true);

const appStore = useAppStore();

const hashParams = new URLSearchParams(decodeURIComponent(window.location.hash.slice(1)));
const specifiedOrigin = hashParams.get("origin");

const closeModal = () => {
  isOpen.value = false;
  // notify parent to hide the iframe
  if (specifiedOrigin) {
    window.parent.postMessage({ type: EMBED_MESSAGE_TYPES.HIDE_NFT_CHECKOUT }, specifiedOrigin);
  } else {
    // TODO: backward compatible, remove this after releasing embed/plugin SDK and use it in new demo app
    window.parent.postMessage("close-nft-checkout", "*");
  }
};

onMounted(() => {
  if (!specifiedOrigin) return; // TODO: backward compatible, remove this after releasing embed/plugin SDK and use it in new demo app
  // notify parent that the iframe is ready
  window.parent.postMessage({ type: EMBED_MESSAGE_TYPES.SETUP_COMPLETE }, specifiedOrigin);

  // listen for message from parent
  window.addEventListener("message", (event) => {
    if (event.origin !== specifiedOrigin) return;
    const { type } = event.data as EmbedMessageData;
    if (type === EMBED_MESSAGE_TYPES.SHOW_NFT_CHECKOUT) {
      const { contractId, receiverAddress } = event.data as ShowNFTCheckoutEmbedMessageData;
      appStore.setContractId(contractId);
      appStore.setReceiverAddress(receiverAddress);
      isOpen.value = true;
    } else if (type === EMBED_MESSAGE_TYPES.INIT) {
      const { clientId } = event.data as InitEmbedMessageData;
      appStore.setClientId(clientId);
    }
  });
});
</script>

<template>
  <Modal
    :open="isOpen"
    :classes="{
      modalContent:
        '@container/wallet !overflow-hidden !rounded-3xl w-[390px] !h-[530px] border-0 py-4 px-4 xs:px-6 !bg-app-light-surface1 dark:!bg-app-dark-surface1',
      clearIcon: '!top-3 !right-3',
      body: '!p-0 h-full flex flex-col gap-3',
    }"
    :backdrop-blur="true"
    :backdrop-close="false"
    @on-close="closeModal()"
  >
    <template #body>
      <slot />
      <Web3authFooter :classes="{ container: '!mt-0' }" />
    </template>
  </Modal>
</template>
